import { TrackableRequestPermissionsDialog } from './requestPermissionsDialog/requestPermissionsDialog';
import { RenameDialog } from './renameDialog/renameDialog';
import { ActivityLogDirective } from './activityLog/activityLog';
import { AuthorizeLinkShareDirective } from'./authorizeLinkShare/authorizeLinkShare';
import { CommentsDirective } from  './comments/comments';
import { ContentSearchResultsDirective } from './contentSearchResults/contentSearchResults';
import { DeletedItemsDirective } from './deletedItems/deletedItems';
import { DocumentDetailsDirective } from './documentDetails/documentDetails';
import { DocumentReplaceHandlerDirective } from './documentReplaceHandler/documentReplaceHandler';
import { DocumentViewDirective } from './documentView/documentView';
import { DropUploadTargetDirective } from './dropUploadTarget/dropUploadTarget';
import { DropUploadWrapperDirective} from './dropUploadWrapper/dropUploadWrapper';
import { EmptyDetailsDirective } from './emptyDetails/emptyDetails';
import { FolderDetailsDirective } from './folderDetails/folderDetails';
import { FolderViewDirective } from './folderView/folderView';
import { MoveItemDialogController } from './moveItemDialog/moveItemDialog';
import { FolderPlaylistDirective } from './folderPlaylist/folderPlaylist';
import { NotificationsDirective } from './notifications/notifications';
import { SharedContentDirective } from './sharedContent/sharedContent';
import { ShareCountDirective } from './shareCount/shareCount';
import { RegisterDirective } from './register/register';
import { TabindexDirective } from './tabindex/tabindex';
import { FullTextSearchResultsDirective } from './fullTextSearchResults/fullTextSearchResults';
import {
	RoleRestrictedSlideFactory,
    UniformTemplatedSlidesController,
    FeatureSlideFactory,
    FeatureHighlightSlidesController,
    SlideDirective,
    SlidesViewDirective
} from './slides/';
import { RequestPermissionsDialog } from './requestPermissionsDialog/requestPermissionsDialog';
import { appAppModule } from './_app/app';
import { myFilesModule } from './_myFiles/myFiles';
import { sharedFilesModule } from './_sharedFiles/sharedFiles';
import { CreateTaskDialog } from './create-task-dialog/create-task-dialog';
import { ActiveUserBarDirective } from './activeUserBar/activeUserBar';
import { MediaEmbeddedDetailsDirective } from './mediaEmbeddedDetails/mediaEmbeddedDetails';
import { TasksComponent } from './tasks/tasks';
import { TasksGridComponent } from './tasks-grid/tasks-grid';
import {
    TaskPanelService,
    TaskPanelButtonComponent
} from './task-panel/task-panel';
import { TaskCommentDialog } from './taskCommentDialog/taskCommentDialog';
import { TasksCardsComponent } from './tasks-cards/tasks-cards';

export const componentsModule = angular  
    .module('sharebase-app.component', [
        'ngMaterial',
        'gettext',
        'sharebase',
        'md.data.table',
        'phoenix.services',
        appAppModule.name,
        myFilesModule.name,
        sharedFilesModule.name
    ])
    .component('sbaTasks', TasksComponent)
    .component('sbaTaskPanelButton', TaskPanelButtonComponent)
    .component('sbaTasksGrid', TasksGridComponent)
    .component('sbaTasksCards', TasksCardsComponent)
    .directive('sbaActivityLog', ActivityLogDirective)
    .directive('sbaAuthorizeLinkShare', AuthorizeLinkShareDirective)
    .directive('sbaComments', CommentsDirective)
    .directive('sbaContentSearchResults', ContentSearchResultsDirective)
    .directive('sbaDeletedItems', DeletedItemsDirective)
    .directive('sbaDocumentDetails', DocumentDetailsDirective)
    .directive('sbaDocumentReplaceHandler', DocumentReplaceHandlerDirective)
    .directive('sbaDocumentView', DocumentViewDirective)
    .directive('sbaDropUploadTarget', DropUploadTargetDirective)
    .directive('sbaDropUploadWrapper', DropUploadWrapperDirective)
    .directive('sbaEmptyDetails', EmptyDetailsDirective)
    .directive('sbaFolderDetails', FolderDetailsDirective)
    .directive('sbaFolderView', FolderViewDirective)
    .directive('sbaFolderPlaylist', FolderPlaylistDirective)
    .directive('sbaFullTextSearchResults', FullTextSearchResultsDirective)
    .directive('sbaNotifications', NotificationsDirective)
    .directive('sbaShareCount', ShareCountDirective)
    .directive('sbaSharedContent', SharedContentDirective)
    .directive('sbaSlide', SlideDirective)
    .directive('sbaSlidesView', SlidesViewDirective)
    .directive('sbaTabindex', TabindexDirective)
    .directive('sbRegister', RegisterDirective)
    .directive('sbaActiveUserBar',ActiveUserBarDirective)
    .directive('sbaMediaEmbeddedDetails',MediaEmbeddedDetailsDirective)
    .service('sbaCreateTaskDialog', CreateTaskDialog)
    .service('sbaFeatureHighlightSlides', FeatureHighlightSlidesController)
	.service('sbaFeatureSlideFactory', FeatureSlideFactory)
    .service('sbaRenameDialog', RenameDialog)
    .service('sbaMoveItemDialog', MoveItemDialogController)
    .service('sbaRequestPermissionDialog', RequestPermissionsDialog)
    .service('sbaRequestPermissionsDialog', TrackableRequestPermissionsDialog)
    .service('sbaRoleRestrictedSlideFactory', RoleRestrictedSlideFactory)
    .service('sbaTaskPanelService', TaskPanelService)
    .service('sbaUniformTemplatedSlides', UniformTemplatedSlidesController)
    .service('sbaTaskCommentDialog', TaskCommentDialog);



// WEBPACK FOOTER //
// ./src/sharebase-app/components/index.ts